import { render, staticRenderFns } from "./BankaHacziTalepEvrakForm.vue?vue&type=template&id=1772c468"
import script from "./BankaHacziTalepEvrakForm.vue?vue&type=script&lang=ts"
export * from "./BankaHacziTalepEvrakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports